import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { routerPropTypes } from 'Types'
import get from 'lodash/get'
import { withRouter } from 'react-router-dom'
import Icon from '../Icon'
import { path, skin } from 'Utils'
import skins from './skins'
import { PAGE_CONTEXT as p } from 'Constants'

const ANT_BROWSE_ID = process.env.ANT_BROWSE_ID

@withRouter
class SearchForm extends Component {
  static propTypes = {
    className: PropTypes.string,
    ...routerPropTypes,
    location: PropTypes.any,
    path: PropTypes.func,
    searchPlaceholderText: PropTypes.string,
    showSubmitButton: PropTypes.bool,
    showSubmitButtonIcon: PropTypes.bool,
    showSubmitButtonText: PropTypes.bool,
    style: PropTypes.object,
    submitButtonIcon: PropTypes.string,
    submitButtonText: PropTypes.string,
    term: PropTypes.string
  }

  state = {
    term: this.props.term || ''
  }

  componentDidMount() {
    this.searchUrl = path(p.PRODUCT_LIST, {
      uuid: ANT_BROWSE_ID,
      subCategory: 'search'
    })
  }

  handleChange = event => {
    var value = event.target.value
    this.setState(function () {
      return {
        term: value
      }
    })
  }

  clearInput = () => {
    this.setState({
      term: ''
    })
  }

  componentDidUpdate(prevProps) {
    const currentPathName = get(this.props.location, 'pathname', '')
    const previousPathName = get(prevProps.location, 'pathname', '')
    const isSearch = currentPathName.indexOf('search') > -1

    if (currentPathName !== previousPathName && !isSearch) {
      this.clearInput()
    }
  }

  handleFormSubmission = e => {
    e.preventDefault()

    this.setState(
      {
        term: e.target.elements.term.value
      },
      () => {
        if (this.state.term !== '') {
          const queryString = `?term=${this.state.term}`

          this.props.history.push(`${this.searchUrl}${queryString}`)
        }
      }
    )
  }

  render() {
    const {
      showSubmitButton = false,
      showSubmitButtonText = false,
      showSubmitButtonIcon = false,
      submitButtonText = 'submit',
      submitButtonIcon = 'search',
      searchPlaceholderText = 'search',
      className = '',
      path = () => {},
      style = {}
    } = this.props

    const searchUrl = path(p.PRODUCT_LIST, {
      uuid: ANT_BROWSE_ID,
      subCategory: 'search'
    })

    return (
      <form
        {...{ style, className }}
        onSubmit={e => this.handleFormSubmission(e)}
        role="search"
        action={searchUrl}
      >
        <input
          className="search-input"
          placeholder={searchPlaceholderText}
          type="search"
          name="term"
          autoComplete="off"
          value={this.state.term}
          onChange={this.handleChange}
        />
        {showSubmitButton && (
          <button className="search-submit" type="submit" value="submit">
            {showSubmitButtonText && <span>{submitButtonText}</span>}
            {showSubmitButtonIcon && (
              <Icon className="search-icon" name={submitButtonIcon} />
            )}
          </button>
        )}
      </form>
    )
  }
}

SearchForm.displayName = 'SearchForm'

export default skin(SearchForm, skins)
